/**
 * Flatten Strapi REST entity `{ id, attributes }` into a single object for app use.
 * No-op if already flat (no `attributes` wrapper).
 */
export function flattenStrapiEntity(entity) {
  if (!entity) return null;
  if (entity.attributes && typeof entity.attributes === "object") {
    return {
      id: entity.id,
      documentId: entity.documentId,
      ...entity.attributes,
    };
  }
  return entity;
}

/**
 * Normalize a relation / repeatable field to a plain array of entities.
 */
export function normalizeStrapiRelationArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (Array.isArray(value.data)) return value.data;
  return [];
}

/**
 * Recursively flatten header menu items and normalize nested sub_menu_items.
 */
export function normalizeHeaderMenuItem(item) {
  if (!item) return null;
  const flat = flattenStrapiEntity(item);
  if (!flat) return null;

  const rawSubs = flat.sub_menu_items ?? flat.subMenuItems;
  const sub_menu_items = normalizeStrapiRelationArray(rawSubs)
    .map(normalizeHeaderMenuItem)
    .filter(Boolean);

  return { ...flat, sub_menu_items };
}

export function normalizeHeaderMenuItems(items) {
  return normalizeStrapiRelationArray(items)
    .map(normalizeHeaderMenuItem)
    .filter(Boolean);
}
